export default __webpack_public_path__ + "static/media/blue-darken-historical.5cfa4118.svg";